var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssessmentReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 137.12 113.02",
    style: {
      enableBackground: "new 0 0 137.12 113.02"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#000000;}\n\t.st1{fill:#FFE400;}\n\t.st2{fill:#0098B5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.64,86.9H26.48V26.12h84.17V86.9z M30.48,82.9h76.17V30.12H30.48V82.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.25,41.98H58.11c-0.83,0-1.5-0.67-1.5-1.5s0.67-1.5,1.5-1.5h41.15c0.83,0,1.5,0.67,1.5,1.5 S100.08,41.98,99.25,41.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.25,52.67H58.11c-0.83,0-1.5-0.67-1.5-1.5s0.67-1.5,1.5-1.5h41.15c0.83,0,1.5,0.67,1.5,1.5 S100.08,52.67,99.25,52.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.25,63.35H58.11c-0.83,0-1.5-0.67-1.5-1.5s0.67-1.5,1.5-1.5h41.15c0.83,0,1.5,0.67,1.5,1.5 S100.08,63.35,99.25,63.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.25,74.03H58.11c-0.83,0-1.5-0.67-1.5-1.5s0.67-1.5,1.5-1.5h41.15c0.83,0,1.5,0.67,1.5,1.5 S100.08,74.03,99.25,74.03z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.46,54.33l-4.41-6.41c-0.47-0.68-0.3-1.62,0.39-2.09c0.68-0.47,1.62-0.3,2.09,0.39l2.15,3.13l7.88-9.59 c0.53-0.64,1.47-0.73,2.11-0.21c0.64,0.53,0.73,1.47,0.21,2.11L39.46,54.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.46,74.8l-4.41-6.41c-0.47-0.68-0.3-1.62,0.39-2.09c0.68-0.47,1.62-0.3,2.09,0.39l2.15,3.13l7.88-9.59 c0.53-0.64,1.47-0.73,2.11-0.21c0.64,0.53,0.73,1.47,0.21,2.11L39.46,74.8z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentReport);
export default __webpack_public_path__ + "static/media/assessment_report.0f73a0472fd9c2e19139aad40fae88c6.svg";
export { ForwardRef as ReactComponent };